class Popup{
	constructor(title, content, closeCallback = ""){
		this.closeCallback 	= closeCallback;
		
		this.popupHtml 		= '<div class="bgPopup"><div class="popupCnt"><div class="pop_hdr"><h1>'+ title +'</h1><div class="closePop"><a href="#"><img src="/img/icons/bw/16/close.png" alt="Close"></a></div></div><div class="pop_content"></div></div><div class="clearem"></div></div>';
		this.popupObj 		= $(this.popupHtml);
		this.popupObj.find(".pop_content").html(content);
	}
	
	open(){
		var self = this;
		if($(".bgPopup").length == 0) {
			$("header").after(this.popupObj);
		}else{
			$(".bgPopup:last").after(this.popupObj);
		}
		
		this.popupObj.fadeIn('fast', function(){
			Popup.resize();
		});
		
		
		this.popupObj.find('.popupCnt .closePop').click(function() {
			if(self.closeCallback){self.closeCallback();}
			self.close();
		});
	}
	
	close(){
		var self = this;
		this.popupObj.fadeOut('fast');
		this.popupObj.children('.popupCnt').fadeOut('fast', function(){
			self.popupObj.remove();
		});
	}
	
	static resize(){
		if($('.popupCnt').length){
			$('.popupCnt').each(function () {
				
				var newHeight = $(this).height();
				var minHeight = 0;
				
				if($('.pop_hdr', this).length){
					minHeight = minHeight + $('.pop_hdr', this).outerHeight();
				}
				if($('.pop_options', this).length){
					minHeight = minHeight + $('.pop_options', this).outerHeight();
				}
				if($('.pop_ftr', this).length){
					minHeight = minHeight + $('.pop_ftr', this).outerHeight();
				}
				
				newHeight = newHeight-minHeight-5;

				$('.pop_content').css('max-height', $('body').height()-minHeight-3);
			});
		}
	}
}

window.Popup = Popup;